import { itemIdOf, rowScalar, statusField } from '../../encounter-map/ft3d/perception';
const LOCKED = '477A7977-60D2-4B9C-96B0-6ED4BFD6437E';
type Row = Record<string, unknown>;
/** Browser twin of the engaged-lock test; installed lock hardware alone is not engagement. */
export function doorLockState(hostId: string, rows: readonly Row[], bindings: readonly { lock_id: string; secured_id: string }[], statuses: (row: Row, side: 'caster' | 'target') => readonly Row[]): boolean {
  const lookup = new Map(rows.map(row => [String(rowScalar(row, 'inventory_id') ?? '').toUpperCase(), row]));
  const host = lookup.get(hostId.toUpperCase());
  if (!host) throw new Error('geometry:door-lock-host-unavailable');
  const ids = new Set([hostId.toUpperCase()]);
  for (const b of bindings) if (b.secured_id.toUpperCase() === hostId.toUpperCase()) ids.add(b.lock_id.toUpperCase());
  for (const status of statuses(host, 'target')) if (itemIdOf(statusField(status, 'status_item_id') ?? status) === LOCKED) {
    const caster = String(statusField(status, 'status_caster_id') ?? '').toUpperCase();
    if (caster) ids.add(caster);
  }
  for (const id of ids) {
    const row = lookup.get(id);
    if (!row) throw new Error('geometry:door-lock-row-unavailable');
    if (['caster', 'target'].some(side => statuses(row, side as 'caster' | 'target').some(status => itemIdOf(statusField(status, 'status_item_id') ?? status) === LOCKED))) return true;
  }
  return false;
}
